<template>
  <div>
    <el-dialog
      top="5vh"
      v-loading="loading"
      :title="'费用管理，项目：'+house_name"
      :visible.sync="dialogVisible"
      width="83%"
      :before-close="handleClose">
      <div style="height: 75vh;overflow-y: auto;">
        <div v-if="date.orderType == '账单操作'">
          <el-button @click="selects_s">查询</el-button>
        </div>
        <div v-if="date.orderType == '新增费用'">
          <el-button @click="add">添加</el-button>
          <el-button @click="orderAddPay">新增并收款</el-button>
          <el-button @click="orderAdd">提交</el-button>
          <el-button @click="close">关闭</el-button>
        </div>
        <div>
          <el-descriptions :column="2" border size="mini" style="margin-top: 10px;" :labelStyle="{width: '123px'}" :contentStyle="{width:'42%'}">
            <el-descriptions-item label="房产信息">
              <el-select v-model="select.house" @change="houses" size="mini" placeholder="可搜索房产" filterable remote clearable reserve-keyword :remote-method="remoteMethod" style="width: 100%;">
                <el-option v-for="item in house" :key="item.id" :label="item.house" :value="item.house"></el-option>
              </el-select>
            </el-descriptions-item>
            <el-descriptions-item label="操作类型">
              <RadioGroup v-model="date.orderType" @on-change="orderTypes">
                  <Radio label="新增费用"></Radio>
                  <!-- <Radio label="账单操作"></Radio> -->
              </RadioGroup>
            </el-descriptions-item>
            <el-descriptions-item label="业户">
              <span style="margin-right: 20px;">{{user.name}}</span>
              <el-button style="color: red;" @click="user_update()">更改业户</el-button>
            </el-descriptions-item>
            <el-descriptions-item  label="">
              <div v-if="ERP.isPermission(4004014)">
                <!-- <router-link to="/pindex/MoneyCheck">
                  <el-button>应收款审核</el-button>
                </router-link> -->
                <el-button @click="MoneyCheck">应收款审核</el-button>
              </div>
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <div v-if="date.orderType == '账单操作'">

        </div>
        <div v-if="date.orderType == '新增费用'">
          <div style="margin-top: 10px;">

            <el-table ref="multipleTable" :data="addList" border tooltip-effect="dark" style="width: 100%" height="53vh">
              <el-table-column label="收费款项" width="150">
                <template slot-scope="scope">
                  <el-select v-model="addList[scope.$index].charge_id" filterable collapse-tags style="width: 100%" placeholder="收费项" @change="chargeitems(addList[scope.$index],scope.$index)">
                    <el-option size="mini" v-for="item in chargeitem" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="计费开始" width="145">
                <template slot-scope="scope">
                  <el-date-picker v-model="addList[scope.$index].startDate" type="date" size="mini" style="width: 100%;"></el-date-picker>
                </template>
              </el-table-column>
              <el-table-column label="计费结束" width="145">
                <template slot-scope="scope">
                  <el-date-picker v-model="addList[scope.$index].endDate" type="date" size="mini" style="width: 100%;"></el-date-picker>
                </template>
              </el-table-column>
              <el-table-column label="应收日期" width="145">
                <template slot-scope="scope">
                  <el-date-picker v-model="addList[scope.$index].should_charge_date" type="date" size="mini" style="width: 100%;"></el-date-picker>
                </template>
              </el-table-column>
              <el-table-column label="单价" width="109">
                <template slot-scope="scope">
                  <el-input size="mini" @change="updateNumder(addList[scope.$index],scope.$index)" v-model="addList[scope.$index].xsc_Price"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="数量/面积" width="109">
                <template slot-scope="scope">
                  <el-input size="mini" @change="updateNumder(addList[scope.$index],scope.$index)" v-model="addList[scope.$index].xsc_Amount"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="收款金额" width="109">
                <template slot-scope="scope">
                  <el-input size="mini" v-model="addList[scope.$index].charge"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="计算方式" width="150">
                <template slot-scope="scope">
                  <el-select v-model="addList[scope.$index].area"  filterable collapse-tags style="width: 100%" @change="areas(addList[scope.$index],scope.$index)">
                    <el-option size="mini" v-for="item in area_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="缴款方式" width="150">
                <template slot-scope="scope">
                  <el-select v-model="addList[scope.$index].payment_id"  filterable collapse-tags style="width: 100%" placeholder="支付方式">
                    <el-option size="mini" v-for="item in dataPay" :key="item.id" :label="item.name" :value="item.id" :disabled="pid != 123 && [5, 9, 26].includes(item.id)"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="备注" width="200">
                <template slot-scope="scope">
                  <el-input size="mini" v-model="addList[scope.$index].remark" placeholder="备注"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="80">
                <template slot-scope="scope">
                  <div @click="del(scope.$index)" style="color: blue;cursor: pointer;">删除</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 弹窗选择用户 -->
    <Modal v-model="modal1" width="950" title="选择客户" @on-ok="roomUser" :z-index="100000000000000">
       <div>
         <room-user
           style="height: 600px"
           ref="child"
           :house="select.house"
         ></room-user>
       </div>
     </Modal>
  </div>
</template>

<script>
export default {
  // 接受父组件的值
  props: {

  },
  watch:{

  },
  components: {
    "room-user": () => import("../../Common/room-user.vue")
  },
  data () {
    return {
      user:[],
      modal1:false,
      chargeitem:[],
      loading_dade:1,
      dialogVisible:false,
      tableData: [],
      order: [],
      money_val:0,
      money:0,
      total:0,
      page:1,
      pageSize:20,
      area_list:[{'id':1,'name':'单价*数量'},{'id':2,'name':'单价*计费面积'},{'id':3,'name':'单价*建筑面积'},{'id':4,'name':'单价*套内面积'}],
      dataPay:[],
      date:{
        money:'单价不一致合并',
        date_s:'',
        date_e:'',
        bill_type:'全部',
        type:'精确查询',
        select:'明细',
        groupType:'票据明细',
        orderType:'新增费用',
      },
      addList:[{
        'charge_id':'',
        'startDate':'',
        'endDate':'',
        'should_charge_date':'',
        'xsc_Price':'',
        'xsc_Amount':1,
        'charge':'',
        'area':'单价*数量',
        'payment_id':'',
        'remark':''
      }],
      select:{
        pay:'',
        house:'',
        name:'',
        date:''
      },
      xsc_bill_no:'',
      house:[],
      remerks:'',
      loading:false,
      pid:'',
      house_name:'',
      ymd:'',
      charging:[]
    }
  },
  mounted(){

  },
  //事件
  methods: {
    MoneyCheck(){
      window.open("/#/pindex/MoneyCheck", '_blank');
    },
    //新增并收款
    orderAddPay(){
      let data = {'house':this.select.house,'data':this.addList,'user':this.user,'type':1};
      this.$confirm('确定要新增并收款吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ERP.showLoading()
        this.$myhttp.post('admin/YcOrder/orderAddPay',data,{
          'Content-Type': 'application/x-www-form-urlencoded'
          }).then(backdata=>{ // 异步执行成功后
            ERP.hideLoading()
            if(backdata.data.code == 200){
              this.dialogVisible = false;
              this.$confirm(''+backdata.data.message, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
              },err=>{});
            }else{
              this.$confirm(''+backdata.data.message, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
              },err=>{});
            }

        },err=>{
          ERP.hideLoading()
          this.$Message.error('请求超时!');
        });
      })
    },

    //提交
    orderAdd(){
      let data = {'house':this.select.house,'data':this.addList,'user':this.user,'type':2};
      this.$confirm('确定要新增吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ERP.showLoading()
        this.$myhttp.post('admin/YcOrder/orderAddPay',data,{
          'Content-Type': 'application/x-www-form-urlencoded'
          }).then(backdata=>{ // 异步执行成功后
            ERP.hideLoading()
            if(backdata.data.code == 200){
              this.dialogVisible = false;
              this.$parent.change(1);
              this.$confirm(''+backdata.data.message, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
              },err=>{});
            }else{
              this.$confirm(''+backdata.data.message, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
              },err=>{});
            }
        },err=>{
          ERP.hideLoading()
          this.$Message.error('请求超时!');
        });
      })
    },

    //选择收费项
    chargeitems(data,index){
      // console.log(data);
      // console.log(data.charge_id);
      // console.log(index);
      this.chargeitem.map(req=>{
        if(req.id == data.charge_id){
          this.addList[index].xsc_Price = req.charge;
          this.addList[index].charge = (this.addList[index].xsc_Price * this.addList[index].xsc_Amount).toFixed(2);
        }
      })
    },
    //修改单价，修改数量
    updateNumder(data,index){
      this.addList[index].charge = (this.addList[index].xsc_Price * this.addList[index].xsc_Amount).toFixed(2);
    },
    //计算方式
    areas(data,index){
      // area_list:[{'id':1,'name':'单价*数量'},{'id':2,'name':'单价*计费面积'},{'id':3,'name':'单价*建筑面积'},{'id':4,'name':'单价*套内面积'}],
      if(data.area == 1){
        this.addList[index].xsc_Amount = 1;
        this.addList[index].charge = (this.addList[index].xsc_Price * this.addList[index].xsc_Amount).toFixed(2);
      }
      if(data.area == 2){
        this.addList[index].xsc_Amount = this.charging[0].charging;
        this.addList[index].charge = (this.addList[index].xsc_Price * this.addList[index].xsc_Amount).toFixed(2);
      }
      if(data.area == 3){
        this.addList[index].xsc_Amount = this.charging[0].area;
        this.addList[index].charge = (this.addList[index].xsc_Price * this.addList[index].xsc_Amount).toFixed(2);
      }
      if(data.area == 4){
        this.addList[index].xsc_Amount = this.charging[0].dwelling_space;
        this.addList[index].charge = (this.addList[index].xsc_Price * this.addList[index].xsc_Amount).toFixed(2);
      }
    },
    //添加条数
    add(){
      this.addList.push({
        'charge_id':'',
        'startDate':this.ymd,
        'endDate':this.ymd,
        'should_charge_date':this.ymd,
        'xsc_Price':'',
        'xsc_Amount':1,
        'charge':'',
        'area':'单价*数量',
        'payment_id':'',
        'remark':''
      });
    },
    //删除
    del(index){
      let data = [];
      this.addList.map((req,ind)=>{
        if(index != ind){
          data.push(req)
        }
      })
      this.addList = data;
    },
    //关闭
    close(){
      // this.$parent.change(1)
      this.dialogVisible = false;
    },
    //返回数据
    getInvo(data,house,pid){
      this.pid = pid;
      this.select = data;
      if(this.date.date_s == ''){
        this.date.date_s  = data.date;
        this.date.date_e = data.date;
      }
      this.house = house;
      this.dialogVisible = true;
      this.selects_s(1);
      this.housePid();
      this.pay();
      this.charge();
      let date = new Date()
      let y = date.getFullYear();
      let m = date.getMonth()+1;
      let d = date.getDate();
      this.ymd = y+"-"+m+"-"+d;
      this.addList[0].startDate = this.ymd;
      this.addList[0].endDate = this.ymd;
      this.addList[0].should_charge_date = this.ymd;
    },
    //收费项
    charge(){
      let data = {'date':this.date,'pid':this.pid}
      this.$myhttp.post('admin/YcOrder/charge',data,{
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata=>{ // 异步执行成功后
        this.chargeitem = backdata.data.data;
      },err=>{
        this.$Message.error('请求异常!');
      });
    },
    //支付方式
    pay(){
      this.$myhttp.get('admin/OrderPayment/index',{
        'Content-Type': 'application/json'
        }).then(backdata=>{
            let dataPay = backdata.data.data;
            this.dataPay = dataPay;
      });
    },
    orderTypes(){
      this.selects_s(1);
    },
    selects_s(){
      this.money = "加载中";
      this.total = 1;
      this.selects(this.pageSize);
    },
    selects(e){
      if(e){
        this.pageSize = e;//1页多少条
      }
      this.loading_dade = 2;
      let data = {'select':this.select,'date':this.date,'xsc_bill_no':this.xsc_bill_no,'remerks':this.remerks,'page':this.page,'pid':this.pid,'pageSize':this.pageSize}
      this.$myhttp.post('admin/OrderList/getlnvoSelect',data,{
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata=>{ // 异步执行成功后
        this.tableData = backdata.data.data;
        if(this.date.orderType != '应收费用账单'){
          this.total = backdata.data.count;
          this.money = backdata.data.money;
        }
        this.loading_dade = 1;
      },err=>{
        this.loading_dade = 1;
        this.$Message.error('请求异常!');
      });
    },
    handleCurrentChange(e){
      this.page = e;//第几页
      this.selects(this.pageSize);
    },
    handleClose(done) {
      done();
    },
    handleSelectionChange(val) {
      this.order = val;
      let money = 0;
      this.order.map(req=>{
        money = Number(money) + Number(req.charge_paid);
      })
      this.money_val = money.toFixed(2);
    },
    print(){
      let id = this.order.map(req=>{return req.id}).join(',');
      if(id == ''){
        this.$Message.error('请选择打印项!');
      }else{
        this.$parent.prin(id,this.date,this.pid);
      }
    },
    //远程搜索
    remoteMethod(query){
      if (query !== '') {
        this.$myhttp.get('admin/common/house_name1?house_name='+encodeURIComponent(query)+'&pid='+this.pid,{
          'Content-Type': 'application/json'
          }).then(backdata=>{ // 异步执行成功后
            this.house = backdata.data.data;
        });
      }
    },
    //更换项目id
    houses(e){
      if(e){
        this.house.map(req=>{
          if(req.house == e){
            //this.pid = req.erp_pindex_id;
          }
        })
      }
      this.housePid();
    },
    //查询当前项目
    housePid(){
      this.$myhttp.get('admin/common/house_pid?pid='+this.pid+"&house="+encodeURIComponent(this.select.house),{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          if(backdata.data.code == 200){
            this.house_name = backdata.data.data.name;
            this.pid = backdata.data.data.id;
            this.charge();
          }
      });
      //获得面积
      let data = {'house':this.select.house};
      this.$myhttp.post('admin/YcOrder/house',data,{
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata=>{ // 异步执行成功后
        this.charging = backdata.data.data;
        this.user = backdata.data.user;
      },err=>{

      });
    },
    //选择业户
    user_update(){
      this.modal1 = true;
    },
    roomUser() {
      let user = this.$refs.child.getUser();
      if (user.id) {
        this.user = user
      }
    },
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Admin/Order/order/orderAdd.vue